import { Component } from '@angular/core';
import { AuthService } from './modules/core/auth/auth.service';
import { Router } from '@angular/router';
import { ThemeService } from './theme.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'biilog_web_cliente';
  public ambiente = false;

  constructor(private authService: AuthService, private router: Router, public theme: ThemeService) {
    this.ambiente = environment.production;
  }

  ngOnInit() {

    const urlAtual = window.location.href;
    if (!this.authService.isAuthenticated() && !urlAtual.includes('autologin')) {
      this.router.navigate(['/home/login']);
    }

  }

}
